<template>
  <span
    class="inline-spinner"
    :style="spinnerStyle"
    aria-hidden="true"
  />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InlineSpinner',
  props: {
    size: {
      type: [Number, String],
      default: 18,
    },
    thickness: {
      type: [Number, String],
      default: 2,
    },
  },
  computed: {
    spinnerStyle() {
      const sizeNum = Number(this.size) || 18;
      const thicknessNum = Number(this.thickness) || 2;
      return {
        width: `${sizeNum}px`,
        height: `${sizeNum}px`,
        borderWidth: `${thicknessNum}px`,
      };
    },
  },
});
</script>

<style scoped>
.inline-spinner {
  display: inline-block;
  border-style: solid;
  border-color: currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: inline-spinner-spin 0.8s linear infinite;
}

@keyframes inline-spinner-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
